export function setCookie(name: string, value: string, date?: number) {
  let seconds = date ? date : 7 * 24 * 60 * 60; // 此 cookie 将被保存的天数
  let exp = new Date(); // 创建一个时间日期对象;
  exp.setTime(exp.getTime() + seconds * 1000);
  document.cookie =
    name + "=" + encodeURI(value) + ";expires=" + exp.toUTCString();
}

export function setCookieByExpire(name: string, value: string, expire: number) {
  let exp = new Date(); // 创建一个时间日期对象;
  exp.setTime(expire);
  document.cookie =
    name + "=" + encodeURI(value) + ";expires=" + exp.toUTCString();
}

export function getCookie(name: string) {
  let arr = document.cookie.match(new RegExp("(^| )" + name + "=([^;]*)(;|$)"));
  if (arr != null) {
    return decodeURI(arr[2]);
  }
  return "";
}

export function deleteCookie(name: string) {
  setCookie(name, "", -1);
}

export class UserCookie {
  public static getInstance(): UserCookie {
    if (this._instance == null) {
      this._instance = new UserCookie();
    }
    return this._instance;
  }
  private static _instance: UserCookie;
  prefix: string = "BIMAir1.0_";

  _name: string = this.prefix + "UserName";
  _id: string = this.prefix + "UserId";
  _account: string = this.prefix + "Account";

  // _role = this.prefix + "UserRole"
  _projectId: string = this.prefix + "ProjectId";
  _projectName: string = this.prefix + "ProjectName";
  _token: string = this.prefix + "Token";
  _key: string = this.prefix + "Key";
  _secret: string = this.prefix + "Secret";

  expire: number = 24 * 60 * 60 * 1000;

  get name() {
    let name = getCookie(this._name);
    return name;
  }

  set name(name) {
    setCookieByExpire(this._name, name, this.expire);
  }

  get id() {
    let id = getCookie(this._id);
    return id;
  }

  set id(id: string) {
    setCookieByExpire(this._id, id, this.expire);
  }

  get account() {
    let account = getCookie(this._account);
    return account;
  }

  set account(account: string) {
    setCookieByExpire(this._account, account, this.expire);
  }

  get projectId() {
    let projectId = getCookie(this._projectId);
    return projectId;
  }

  set projectId(projectId: string) {
    setCookieByExpire(this._projectId, projectId, this.expire);
  }

  get projectName() {
    let projectName = getCookie(this._projectName);
    return projectName;
  }

  set projectName(projectName: string) {
    setCookieByExpire(this._projectName, projectName, this.expire);
  }

  get token() {
    let token = getCookie(this._token);
    return token;
  }

  set token(token: string) {
    setCookieByExpire(this._token, token, this.expire);
  }

  get key() {
    let key = getCookie(this._key);
    return key;
  }

  set key(key: string) {
    setCookieByExpire(this._key, key, this.expire);
  }

  get secret() {
    let secret = getCookie(this._secret);
    return secret;
  }

  set secret(secret: string) {
    setCookieByExpire(this._secret, secret, this.expire);
  }

  // projectId(projectId?) {
  //   if (projectId) {
  //     setCookie(this._projectId, projectId);
  //   }
  //   return getCookie(this._projectId)

  // }

  login(name: string, id: string) {
    setCookie(this._name, name, 7);
    setCookie(this._id, id, 7);
    // setCookie(this._role, role, 7);
  }

  logout() {
    deleteCookie(this._name);
    deleteCookie(this._id);
    // deleteCookie(this._role)
  }

  // role() {
  //     let role = getCookie(this._role)
  //     return role
  // }

  isLogin() {
    return getCookie(this._name) && getCookie(this._id);
  }
}
